import React from 'react';
import { bool, func, string, any } from 'prop-types';
import SlidingPane from 'react-sliding-pane';

function ReactSlidingPane({ state, onClose, width = '40%', title = '', subtitle = '', children, shouldCloseOnEsc = false, className }) {
  return (
    <SlidingPane
      title={title}
      subtitle={subtitle}
      className={className}
      closeIcon={
        <div>
          <span style={{ fontSize: '1.5em' }} aria-hidden="true">
            &times;
          </span>
        </div>
      }
      width={width}
      isOpen={state}
      onRequestClose={onClose}
      shouldCloseOnEsc={shouldCloseOnEsc}
    >
      {children || <div>Hello, you can add the children here</div>}
    </SlidingPane>
  );
}

ReactSlidingPane.propTypes = {
  state: bool.isRequired,
  onClose: func.isRequired,
  width: string,
  title: string,
  subtitle: string,
  children: any,
  shouldCloseOnEsc: bool,
  className: string,
};
ReactSlidingPane.defaultProps = {};

export default ReactSlidingPane;
